/******************************************************************************
 *
 * FILE:
 * src/modules/wms/workspace/executor/services/wmsExecutorWorkspaceService.js
 *
 * MODULE:
 * Work Management System (WMS)
 *
 * FEATURE:
 * Executor Workspace
 *
 * DESCRIPTION:
 * Service layer for Executor Workspace.
 *
 * Phase-2:
 * Loads Executor Workspace from backend while preserving
 * the existing response contract expected by the page.
 *
 ******************************************************************************/

import axiosClient from "../../../../../api/axiosClient";

// ============================================================================
// EXECUTOR WORKSPACE SERVICE
// ============================================================================

const wmsExecutorWorkspaceService = {

    // ==========================================================
    // GET EXECUTOR WORKSPACE
    // ==========================================================

    async getExecutorWorkspace(filters = {}) {

        const response = await axiosClient.get(
            "/api/wms/works",
            {
                params: {
                    page: 1,
                    per_page: 100,
                    ...filters,
                },
            }
        );

        const result = response.data.data || {};

        return {

            // --------------------------------------------------
            // Temporary placeholders
            // These will be built from backend data
            // in the next step.
            // --------------------------------------------------

            summary: {},

            resumeWork: null,

            priorityWork: null,

            // --------------------------------------------------
            // Work List
            // --------------------------------------------------

            works: result.data || [],

            // --------------------------------------------------
            // Pagination
            // --------------------------------------------------

            pagination: result.pagination || {},

        };

    },

    // ==========================================================
    // GET EXECUTION WORKSPACE
    // ==========================================================

    async getExecutionWorkspace(workId) {

        const response = await axiosClient.get(

            `/api/wms/works/${workId}/execution`

        );

        return response.data.data;

    },

    // ==========================================================
    // ADD COMMENT
    // ==========================================================

    async addComment(
        workId,
        commentText
    ) {

        const response = await axiosClient.post(

            `/api/wms/works/${workId}/comments`,

            {
                comment_text: commentText,
            }

        );

        return response.data.data;

    },

};

export default wmsExecutorWorkspaceService;